import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { firstValueFrom } from 'rxjs'

import { environment } from '../../../environments/environment'

// WebKit can abort a download whose object URL is revoked in the same task as
// the click that started it, so the URL is held briefly before release.
export const OBJECT_URL_LIFETIME_MS = 250

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {
  constructor(private http: HttpClient) {}

  /**
   * Fetches an API path through HttpClient so KeycloakBearerInterceptor
   * attaches the token, then hands the response to the browser as a file to
   * save. A plain anchor href carries no token and so reaches public
   * endpoints only.
   */
  async download(path: string, filename: string): Promise<void> {
    const blob = await firstValueFrom(
      this.http.get(`${environment.apiBaseUrl}/${path}`, {
        responseType: 'blob'
      })
    )

    const objectUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')

    link.href = objectUrl
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    setTimeout(() => URL.revokeObjectURL(objectUrl), OBJECT_URL_LIFETIME_MS)
  }
}
